var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "svgicon svgicon--shopping-cart" }, [
    _c(
      "svg",
      {
        attrs: {
          width: _vm.iconSize,
          viewBox: "0 0 24 24",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xml:space": "preserve"
        }
      },
      [
        _c("path", {
          style: "fill: " + _vm.color + ";",
          attrs: {
            d:
              "M0.5,3H4c0.232,0,0.434,0.16,0.487,0.386L5.809,9H23.5c0.161,0,0.313,0.077,0.406,0.208s0.119,0.299,0.068,0.451l-3,9  C20.906,18.862,20.716,19,20.5,19H8.161l0.235,1H19c1.104,0,2,0.898,2,2c0,1.104-0.896,2-2,2c-1.103,0-2-0.896-2-2  c0-0.365,0.106-0.704,0.278-1H9.723C9.895,21.296,10,21.635,10,22c0,1.104-0.896,2-2,2c-1.103,0-2-0.896-2-2  c0-0.89,0.588-1.637,1.394-1.896L3.604,4H0.5C0.225,4,0,3.776,0,3.5S0.225,3,0.5,3z"
          }
        })
      ]
    ),
    _vm._v(" "),
    _vm.itemsCount > 0
      ? _c(
          "span",
          {
            staticClass: "layoutHeaderButton__badge",
            style: "background-color: " + _vm.colorOfBadge + ";"
          },
          [_vm._v(_vm._s(_vm.itemsCount))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }